
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState, useEffect } from 'react';

export default function AddTrasladoForm() {
    const [formData, setFormData] = useState({
        terceroId: '',
        fecha: '',
        observaciones: '-',
        sepulturaId: '',
        origenId: '',
        destineId: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [terceros, setTerceros] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchTerceros = async () => {
            try {
                const response = await axios.get('/terceros');
                setTerceros(response.data);
            } catch (err) {
                console.error('Error fetching terceros:', err);
            }
        };
        fetchTerceros();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleTerceroInputChange = (e) => {
        const value = e.target.value;
        setFormData({ ...formData, terceroId: value });

        if (terceros.some(tercero => tercero.documento.toString() === value)) {
            setErrors({ ...errors, terceroId: '' });
        }
    };

    const handleTerceroSelect = (documento) => {
        const selectedTercero = terceros.find((tercero) => tercero.documento.toString() === documento);
        if (selectedTercero) {
            setFormData({ ...formData, terceroId: selectedTercero.documento });
            setErrors({ ...errors, terceroId: '' });
        }
    };

    const filteredTerceros = terceros.filter(
        (tercero) =>
            formData.terceroId.length >= 2 && (
                tercero.nombre.toLowerCase().includes(formData.terceroId.toLowerCase()) ||
                tercero.documento.toString().includes(formData.terceroId)
            )
    );

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = {};
        if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
        if (!formData.fecha) validationErrors.fecha = 'El campo Fecha es obligatorio.';
        if (!formData.sepulturaId) validationErrors.sepulturaId = 'El campo Sepultura ID es obligatorio.';
        if (!formData.origenId) validationErrors.origenId = 'El campo Origen ID es obligatorio.';
        if (!formData.destineId) validationErrors.destineId = 'El campo Destino ID es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post('/traslados', {
                    terceroId: formData.terceroId,
                    fecha: formData.fecha,
                    observaciones: formData.observaciones || '',
                    sepulturaId: parseInt(formData.sepulturaId, 10),
                    origenId: parseInt(formData.origenId, 10),
                    destineId: parseInt(formData.destineId, 10)
                });
                navigate('/home/traslados');
            } catch (err) {
                console.error('Error saving traslado:', err);
                setErrors({ submit: 'Error al guardar el traslado. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6 text-center">Añadir Nuevo Traslado</h2>
            <form onSubmit={handleSubmit} className="bg-blue-100 shadow-md rounded px-8 pt-6 pb-8 mb-4">
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="terceroId">Buscar y Seleccionar Tercero</label>
                    <input
                        type="text"
                        name="terceroId"
                        value={formData.terceroId}
                        onChange={handleTerceroInputChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        placeholder="Buscar por nombre o documento (mínimo 2 caracteres)"
                        autoComplete="off"
                    />
                    {filteredTerceros.length > 0 && (
                        <ul className="border rounded mt-2 bg-white shadow-md max-h-40 overflow-y-auto">
                            {filteredTerceros.map((tercero) => (
                                <li
                                    key={tercero.documento}
                                    onClick={() => handleTerceroSelect(tercero.documento)}
                                    className="px-4 py-2 cursor-pointer hover:bg-blue-200"
                                >
                                    {tercero.nombre} - {tercero.documento}
                                </li>
                            ))}
                        </ul>
                    )}
                    {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
                </div>

                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="fecha">Fecha</label>
                        <input type="date" name="fecha" value={formData.fecha} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                        {errors.fecha && <p className="text-red-500 text-xs italic">{errors.fecha}</p>}
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="observaciones">Observaciones</label>
                        <textarea name="observaciones" value={formData.observaciones} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Observaciones" />
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="sepulturaId">Sepultura ID</label>
                        <input type="text" name="sepulturaId" value={formData.sepulturaId} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Sepultura ID" />
                        {errors.sepulturaId && <p className="text-red-500 text-xs italic">{errors.sepulturaId}</p>}
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="origenId">Origen ID</label>
                        <input type="text" name="origenId" value={formData.origenId} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Origen ID" />
                        {errors.origenId && <p className="text-red-500 text-xs italic">{errors.origenId}</p>}
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="destineId">Destino ID</label>
                        <input type="text" name="destineId" value={formData.destineId} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Destino ID" />
                        {errors.destineId && <p className="text-red-500 text-xs italic">{errors.destineId}</p>}
                    </div>
                </div>
                <div className="flex items-center justify-center mt-6">
                    <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" disabled={isLoading}>
                        {isLoading ? 'Guardando...' : 'Guardar Traslado'}
                    </button>
                </div>
            </form>
        </div>
    );
}


/* correcto creo
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddTrasladoForm() {
    const [formData, setFormData] = useState({
        terceroId: '',
        fecha: '',
        observaciones: '',
        sepulturaId: '',
        origenId: '',
        destineId: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = {};
        if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
        if (!formData.fecha) validationErrors.fecha = 'El campo Fecha es obligatorio.';
        if (!formData.sepulturaId) validationErrors.sepulturaId = 'El campo Sepultura ID es obligatorio.';
        if (!formData.origenId) validationErrors.origenId = 'El campo Origen ID es obligatorio.';
        if (!formData.destineId) validationErrors.destineId = 'El campo Destino ID es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post('/traslados', {
                    terceroId: formData.terceroId,
                    fecha: formData.fecha,
                    observaciones: formData.observaciones || '',
                    sepulturaId: parseInt(formData.sepulturaId, 10),
                    origenId: parseInt(formData.origenId, 10),
                    destineId: parseInt(formData.destineId, 10)
                });
                navigate('/home/traslados');
            } catch (err) {
                console.error('Error saving traslado:', err);
                setErrors({ submit: 'Error al guardar el traslado. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6 text-center">Añadir Nuevo Traslado</h2>
            <form onSubmit={handleSubmit} className="bg-blue-100 shadow-md rounded px-8 pt-6 pb-8 mb-4">
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="terceroId">Tercero ID</label>
                        <input type="text" name="terceroId" value={formData.terceroId} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Tercero ID" />
                        {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="fecha">Fecha</label>
                        <input type="date" name="fecha" value={formData.fecha} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                        {errors.fecha && <p className="text-red-500 text-xs italic">{errors.fecha}</p>}
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="observaciones">Observaciones</label>
                        <textarea name="observaciones" value={formData.observaciones} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Observaciones" />
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="sepulturaId">Sepultura ID</label>
                        <input type="text" name="sepulturaId" value={formData.sepulturaId} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Sepultura ID" />
                        {errors.sepulturaId && <p className="text-red-500 text-xs italic">{errors.sepulturaId}</p>}
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="origenId">Origen ID</label>
                        <input type="text" name="origenId" value={formData.origenId} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Origen ID" />
                        {errors.origenId && <p className="text-red-500 text-xs italic">{errors.origenId}</p>}
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="destineId">Destino ID</label>
                        <input type="text" name="destineId" value={formData.destineId} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Destino ID" />
                        {errors.destineId && <p className="text-red-500 text-xs italic">{errors.destineId}</p>}
                    </div>
                </div>
                <div className="flex items-center justify-center mt-6">
                    <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" disabled={isLoading}>
                        {isLoading ? 'Guardando...' : 'Guardar Traslado'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/



/* CORRECTO error no graba
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddTrasladoForm() {
    const [formData, setFormData] = useState({
        terceroId: '',
        fecha: '',
        observaciones: '-',
        sepulturaId: '',
        origenId: '',
        destineId: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = {};
        if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
        if (!formData.fecha) validationErrors.fecha = 'El campo Fecha es obligatorio.';
        if (!formData.sepulturaId) validationErrors.sepulturaId = 'El campo Sepultura ID es obligatorio.';
        if (!formData.origenId) validationErrors.origenId = 'El campo Origen ID es obligatorio.';
        if (!formData.destineId) validationErrors.destineId = 'El campo Destino ID es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post('/traslados', {
                    terceroId: formData.terceroId,
                    fecha: formData.fecha,
                    observaciones: formData.observaciones || '',
                    sepulturaId: parseInt(formData.sepulturaId, 10),
                    origenId: parseInt(formData.origenId, 10),
                    destineId: parseInt(formData.destineId, 10)
                });
                navigate('/home/traslados');
            } catch (err) {
                console.error('Error saving traslado:', err);
                setErrors({ submit: 'Error al guardar el traslado. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6 text-center">Añadir Nuevo Traslado</h2>
            <form onSubmit={handleSubmit} className="bg-blue-100 shadow-md rounded px-8 pt-6 pb-8 mb-4">
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="terceroId">Tercero ID</label>
                        <input type="text" name="terceroId" value={formData.terceroId} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Tercero ID" />
                        {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="fecha">Fecha</label>
                        <input type="date" name="fecha" value={formData.fecha} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                        {errors.fecha && <p className="text-red-500 text-xs italic">{errors.fecha}</p>}
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="observaciones">Observaciones</label>
                        <textarea name="observaciones" value={formData.observaciones} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Observaciones" />
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="sepulturaId">Sepultura ID</label>
                        <input type="text" name="sepulturaId" value={formData.sepulturaId} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Sepultura ID" />
                        {errors.sepulturaId && <p className="text-red-500 text-xs italic">{errors.sepulturaId}</p>}
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="origenId">Origen ID</label>
                        <input type="text" name="origenId" value={formData.sepulturaId} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Origen ID" />
                        {errors.origenId && <p className="text-red-500 text-xs italic">{errors.origenId}</p>}
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="destineId">Destino ID</label>
                        <input type="text" name="destineId" value={formData.destineId} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Destino ID" />
                        {errors.destineId && <p className="text-red-500 text-xs italic">{errors.destineId}</p>}
                    </div>
                </div>
                <div className="flex items-center justify-center mt-6">
                    <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" disabled={isLoading}>
                        {isLoading ? 'Guardando...' : 'Guardar Traslado'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/

/* CORRECTO
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddTrasladoForm() {
    const [formData, setFormData] = useState({
        terceroId: '',
        fecha: '',
        observaciones: '',
        sepulturaId: '',
        origenId: '',
        destineId: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = {};
        if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
        if (!formData.fecha) validationErrors.fecha = 'El campo Fecha es obligatorio.';
        if (!formData.sepulturaId) validationErrors.sepulturaId = 'El campo Sepultura ID es obligatorio.';
        if (!formData.origenId) validationErrors.origenId = 'El campo Origen ID es obligatorio.';
        if (!formData.destineId) validationErrors.destineId = 'El campo Destino ID es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post('/traslados', {
                    terceroId: formData.terceroId,
                    fecha: formData.fecha,
                    observaciones: formData.observaciones || '',
                    sepulturaId: parseInt(formData.sepulturaId, 10),
                    origenId: parseInt(formData.origenId, 10),
                    destineId: parseInt(formData.destineId, 10)
                });
                navigate('/home/traslados');
            } catch (err) {
                console.error('Error saving traslado:', err);
                setErrors({ submit: 'Error al guardar el traslado. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6 text-center">Añadir Nuevo Traslado</h2>
            <form onSubmit={handleSubmit} className="bg-blue-100 shadow-md rounded px-8 pt-6 pb-8 mb-4">
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="terceroId">Tercero ID</label>
                        <input type="text" name="terceroId" value={formData.terceroId} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Tercero ID" />
                        {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="fecha">Fecha</label>
                        <input type="date" name="fecha" value={formData.fecha} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                        {errors.fecha && <p className="text-red-500 text-xs italic">{errors.fecha}</p>}
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="observaciones">Observaciones</label>
                        <textarea name="observaciones" value={formData.observaciones} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Observaciones" />
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="sepulturaId">Sepultura ID</label>
                        <input type="text" name="sepulturaId" value={formData.sepulturaId} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Sepultura ID" />
                        {errors.sepulturaId && <p className="text-red-500 text-xs italic">{errors.sepulturaId}</p>}
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="origenId">Origen ID</label>
                        <input type="text" name="origenId" value={formData.origenId} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Origen ID" />
                        {errors.origenId && <p className="text-red-500 text-xs italic">{errors.origenId}</p>}
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="destineId">Destino ID</label>
                        <input type="text" name="destineId" value={formData.destineId} onChange={handleChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Destino ID" />
                        {errors.destineId && <p className="text-red-500 text-xs italic">{errors.destineId}</p>}
                    </div>
                </div>
                <div className="flex items-center justify-center mt-6">
                    <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" disabled={isLoading}>
                        {isLoading ? 'Guardando...' : 'Guardar Traslado'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/


/*
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddTrasladoForm() {
    const [formData, setFormData] = useState({
        terceroId: '',
        fecha: '',
        observaciones: '',
        sepulturaId: '',
        origenId: '',
        destineId: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validación básica
        const validationErrors = {};
        if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
        if (!formData.fecha) validationErrors.fecha = 'El campo Fecha es obligatorio.';
        if (!formData.sepulturaId) validationErrors.sepulturaId = 'El campo Sepultura ID es obligatorio.';
        if (!formData.origenId) validationErrors.origenId = 'El campo Origen ID es obligatorio.';
        if (!formData.destineId) validationErrors.destineId = 'El campo Destino ID es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post('/traslados', {
                    terceroId: formData.terceroId,
                    fecha: formData.fecha,
                    observaciones: formData.observaciones || '',
                    sepulturaId: parseInt(formData.sepulturaId, 10),
                    origenId: parseInt(formData.origenId, 10),
                    destineId: parseInt(formData.destineId, 10)
                });
                navigate('/home/traslados');
            } catch (err) {
                console.error('Error saving traslado:', err);
                setErrors({ submit: 'Error al guardar el traslado. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6">Añadir Nuevo Traslado</h2>
            <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="terceroId">
                        Tercero ID
                    </label>
                    <input
                        type="text"
                        name="terceroId"
                        value={formData.terceroId}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.terceroId ? 'border-red-500' : ''}`}
                        placeholder="Tercero ID del traslado"
                    />
                    {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
                </div>
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="fecha">
                        Fecha
                    </label>
                    <input
                        type="date"
                        name="fecha"
                        value={formData.fecha}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.fecha ? 'border-red-500' : ''}`}
                    />
                    {errors.fecha && <p className="text-red-500 text-xs italic">{errors.fecha}</p>}
                </div>
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="observaciones">
                        Observaciones
                    </label>
                    <textarea
                        name="observaciones"
                        value={formData.observaciones}
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        placeholder="Observaciones del traslado"
                    />
                </div>
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="sepulturaId">
                        Sepultura ID
                    </label>
                    <input
                        type="text"
                        name="sepulturaId"
                        value={formData.sepulturaId}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.sepulturaId ? 'border-red-500' : ''}`}
                        placeholder="Sepultura ID"
                    />
                    {errors.sepulturaId && <p className="text-red-500 text-xs italic">{errors.sepulturaId}</p>}
                </div>
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="origenId">
                        Origen ID
                    </label>
                    <input
                        type="text"
                        name="origenId"
                        value={formData.origenId}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.origenId ? 'border-red-500' : ''}`}
                        placeholder="Origen ID"
                    />
                    {errors.origenId && <p className="text-red-500 text-xs italic">{errors.origenId}</p>}
                </div>
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="destineId">
                        Destino ID
                    </label>
                    <input
                        type="text"
                        name="destineId"
                        value={formData.destineId}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.destineId ? 'border-red-500' : ''}`}
                        placeholder="Destino ID"
                    />
                    {errors.destineId && <p className="text-red-500 text-xs italic">{errors.destineId}</p>}
                </div>
                <div className="flex items-center justify-between">
                    <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" disabled={isLoading}>
                        {isLoading ? 'Guardando...' : 'Guardar Traslado'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/